export default __webpack_public_path__ + "static/ScreenCrowStudiosLogo-e6be137fdf8a4d78c8dd2625ef84f917.png";